"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/ModalBase/ModalBase.context.ts
const [ModalBaseProvider, useModalBaseContext] = createSafeContext("ModalBase component was not found in tree");
//#endregion
export { ModalBaseProvider, useModalBaseContext };

//# sourceMappingURL=ModalBase.context.mjs.map